import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    main: {
      '& .MuiDialog-paper': {
        backgroundColor: '#e0ede1',
        maxWidth: '31.2rem',
      },

      '& .MuiDialogTitle-root': {
        paddingTop: '2.4rem',

        '& h1': {
          fontWeight: 500,
        },
      },

      '& .MuiDialogContent-root': {
        paddingTop: 0,

        '& p': {
          fontSize: '1.4rem',
        },
      },
      '& .MuiDialogActions-root': {
        paddingBottom: '2.4rem',

        '& button': {
          width: 'max-content',
          margin: 0,
        },
      },
    },
  }),
)
